<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';

/********************
 * PROPS & EMITS     *
 ********************/
export interface CiSkeletonCampsiteDetailAvailabilityTileProps {
  hasAvailabilities?: boolean;
}
const props = withDefaults(defineProps<CiSkeletonCampsiteDetailAvailabilityTileProps>(), {
  hasAvailabilities: false,
});
</script>

<template>
  <div>
    <div
      class="relative block overflow-hidden border border-gray-20 bg-white md:h-[14.4375rem] lg:h-[12.6875rem] xl:h-[15.1875rem]"
      :class="[
        props.hasAvailabilities
          ? 'rounded-b-none rounded-t-lg border-b-0'
          : 'rounded-lg',
      ]"
    >
      <div class="grid h-full grid-cols-3">
        <div class="relative col-span-3 md:col-span-1">
          <CiSkeletonItem class="h-full pt-[75%]" />
        </div>

        <div class="col-span-3 h-full md:col-span-2">
          <div class="ml-0 h-full p-2 md:ml-2">
            <div class="md:min-h-auto flex h-full min-h-[100px] flex-col gap-y-2">
              <CiSkeletonItem class="block h-5 w-[30%]" />
              <CiSkeletonItem class="block h-[30px] w-[70%]" />
              <CiSkeletonItem v-if="!hasAvailabilities" class="mt-auto h-[40px] w-full rounded-[2.344rem] md:ml-auto md:w-5/12" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="hasAvailabilities"
      class="h-[100px] w-full overflow-hidden rounded-lg rounded-t-none border border-t-0 border-gray-20 bg-white"
    />
  </div>
</template>
